export default __webpack_public_path__ + "1a819c2e5d9a70673a0405ca0abd0fe2.svg";